import { Component, OnInit, AfterViewInit, OnDestroy, Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Subscription } from 'rxjs/Subscription';
import { CadetapplicationpreviewService } from '../_services/cadetapplicationpreview.service';
import 'rxjs/Rx';

@Component({
  selector: 'app-cadetconfirmationapplication',
  templateUrl: './cadetconfirmationapplication.component.html',
  styleUrls: ['./cadetconfirmationapplication.component.css']
})

export class CadetconfirmationapplicationComponent implements OnDestroy {
  displayCadetData;
  applicationDate;
  applicationConfNumber;
  applicantFName;
  applicantLName;
  applicantEmailAddr;
  subscription: Subscription;
  //cadetEmailApi = "rest/public/send_email/";

  constructor(private http: HttpClient, private _CadetapplicationpreviewService: CadetapplicationpreviewService) {
    // setTimeout(() => {
    //   this.sendEmailCadet();
    // }, 1000);
  }

  ngOnInit() {
    this.subscription = this._CadetapplicationpreviewService.sharedCadetFormData$.subscribe((res) => this.displayCadetData = res);
    this.applicationDate = ((new Date().getMonth() + 1) + '/' + new Date().getDate() + '/' + new Date().getFullYear());
    this.subscription = this._CadetapplicationpreviewService.getCadetConfNumber$.subscribe((res) => this.applicationConfNumber = res);
    this.applicantFName = this.displayCadetData.firstNamePers;
    this.applicantLName = this.displayCadetData.lastNamePers;
    this.applicantEmailAddr = this.displayCadetData.emailAddrPers;
  }

  // sendEmailCadet() {
  //   this.http.get(this.cadetEmailApi + this.applicantEmailAddr + "/" + this.applicantFName + "/" + this.applicantLName + "/" + this.applicationConfNumber.conMsg)
  //     .subscribe(
  //       (data) => {

  //       },
  //       response => {

  //       },
  //       () => {

  //       })
  // }

  ngAfterViewInit() {
    window.scrollTo(0, 0);
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}


// WEBPACK FOOTER //
// ./src/app/cadetconfirmationapplication/cadetconfirmationapplication.component.ts